document.addEventListener("DOMContentLoaded", function () {

  /* Prevent duplicate snow container */
  if (document.getElementById("snow-container")) return;

  /* Create container */
  const snowContainer = document.createElement("div");
  snowContainer.id = "snow-container";
  document.body.appendChild(snowContainer);

  const snowflakeCount = window.innerWidth < 768 ? 40 : 80;

  for (let i = 0; i < snowflakeCount; i++) {
    const snow = document.createElement("div");
    snow.className = "snowflake";
    snow.innerHTML = "❄";

    snow.style.left = Math.random() * 100 + "vw";
    snow.style.animationDuration = Math.random() * 7 + 6 + "s";
    snow.style.fontSize = Math.random() * 10 + 12 + "px";
    snow.style.opacity = Math.random() * 0.4 + 0.6;

    snowContainer.appendChild(snow);
  }
});
